export default "__VITE_ASSET__CJtxwwF5__"